module.exports = __webpack_public_path__ + "static/img/award5.2990bbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/award5.png
// module id = Cp7Z
// module chunks = 7